import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            maxWidth: remCalc(1440),
            margin: '0 auto',
            py: ['small-1.base', 'small-1.sm', 'small-1.md', 'medium.lg'],
            px: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'medium.lg'],
        },
        header: {
            direction: 'column',
            align: 'flex-start',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
            maxWidth: remCalc(768),
        },
        subtitle: {
            textStyle: 'head-large',
            fontWeight: 'light',
            color: 'foreground.neutral.subtle',
            fontFamily: 'heading',
        },
        title: {
            textStyle: 'head-large',
            fontWeight: 'light',
            color: 'foreground.neutral.default',
            fontFamily: 'heading',
        },
        grid: {
            columns: {base: 1, md: 2, xl: 4},
            gap: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'medium.lg'],
            marginTop: ['small-1.base', 'small-1.sm', 'small-1.md', 'medium.lg'],
        },
        card: {
            direction: 'column',
            align: 'flex-start',
            gap: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            minHeight: '100%',
            py: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            pr: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },
        cardContent: {
            direction: 'column',
            align: 'flex-start',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
        },
        icon: {
            boxSize: remCalc(20),
            objectFit: 'contain',
            color: 'foreground.neutral.default',
        },
        cardTitle: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        description: {
            textStyle: 'body-small',
            color: 'foreground.neutral.muted',
            fontWeight: 'normal',
        },
    },
}
